<template>
  <div class="batch-search" id="printInfo">
    <div class="top-box">
      <div class="top-title">填报信息</div>
      <div class="archive-info-container" 
        :header-cell-style="{background:'#e6e6e6', color: '#646464'}"
        v-loading="archiveInfoLoading">
          <p v-if="!this.archiveInfoLoading">{{this.yearTag}}年 {{this.provinceNameTag}} {{this.studentNameTag}} {{this.subjectTag}}  分数:{{this.scoreRangeTag}}</p>
      </div>
    </div>

    <div class="table-container-body">
      <el-table v-if="tableShow" :data="tableData" height="660" stripe class="table-body" ref="tableData" row-key="id"
      :header-cell-style="{background:'#e6e6e6', color: '#646464'}"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      default-expand-all
      v-loading="tableLoading">
      <el-table-column prop="index" label="序号" :show-overflow-tooltip="true" min-width="80">
        <template slot-scope="scope">
          <span v-if="!scope.row.isChild">{{scope.row.index}}</span>
        </template>
      </el-table-column>
        <el-table-column label="" v-if="showSortCloumn"  min-width="50" >
          <template v-if="showSortCloumn">
            <i class="el-icon-rank handle-sort"></i>
          </template>
        </el-table-column>
        <el-table-column prop="isChild"   min-width="50">
          <template slot-scope="scope">
            <div style="display:flex;flex-direction:column">
              <i class="el-icon-caret-top" v-if="scope.row.isChild && scope.row.index !=0" style="cursor: pointer;" @click="handleChildClickup(scope.row)"></i>
              <i class="el-icon-caret-bottom" v-if="scope.row.isChild && scope.row.index != scope.row.len-1" style="cursor: pointer;" @click="handleChildClickdown(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
        <!-- tableHeader:{
        '序号':'index',
        '院校code':'code',
        '院校/专业备注':'school',
        '院校专业':'major',
        '地区':'province',
        '院校层次':'level',
        '录取原则':'-',
        '学制/学费招生计划比':'tuition',
        '去年录取分参考分':'segment',
        '学科评估':'-',
        '保研率':'-',
        '备注':'remark'
      } -->
        <el-table-column prop="groupCode" label="院校专业代码" :show-overflow-tooltip="true" min-width="150"></el-table-column>
        <el-table-column prop="school" label="院校/专业备注" :show-overflow-tooltip="true" min-width="200"></el-table-column>
        <el-table-column prop="major" label="院校专业" :show-overflow-tooltip="true" min-width="200"></el-table-column>
        <el-table-column prop="province" label="地区" :show-overflow-tooltip="true" min-width="100"></el-table-column>
        <el-table-column prop="level" label="院校层次" :show-overflow-tooltip="true" min-width="100"></el-table-column>
        <el-table-column prop="majorRequire" label="录取原则" :show-overflow-tooltip="true" min-width="120"></el-table-column>
        <el-table-column prop="tuition" label="学制/学费" :show-overflow-tooltip="true" min-width="100"></el-table-column>
        <el-table-column prop="compare" label="招生计划对比2025/2026" :show-overflow-tooltip="true" min-width="110"></el-table-column>
        <el-table-column prop="segment" label="2025年录取分" :show-overflow-tooltip="true" min-width="100"></el-table-column>
        <el-table-column prop="forecast" label="参考分" :show-overflow-tooltip="true" min-width="100"></el-table-column>
        <!-- <el-table-column prop="subjectAssessment" label="学科评估" :show-overflow-tooltip="true" min-width="150"></el-table-column> -->
        <el-table-column prop="retentionRate" label="保研率" :show-overflow-tooltip="true" min-width="150"></el-table-column>
        <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" min-width="150"></el-table-column>

        <!-- <el-table-column prop="province" label="省份" :show-overflow-tooltip="true" width="100"></el-table-column>
        <el-table-column prop="city" label="城市" :show-overflow-tooltip="true" width="100"></el-table-column>
        <el-table-column prop="school" label="院校" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="major" label="专业" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="requireSub" label="选科要求" :show-overflow-tooltip="true" width="120"></el-table-column>
        <el-table-column prop="level" label="院校层次" :show-overflow-tooltip="true" width="80"></el-table-column>
        <el-table-column prop="tuition" label="学制/学费" :show-overflow-tooltip="true" width="100"></el-table-column>
        <el-table-column prop="compare" label="招生计划对比2022/2023" :show-overflow-tooltip="true" width="110"></el-table-column>
        <el-table-column prop="segment" label="2022年录取分" :show-overflow-tooltip="true" width="130"></el-table-column>
        <el-table-column prop="forecast" label="参考分" :show-overflow-tooltip="true" width="120"></el-table-column>
        <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" width="150"></el-table-column> -->
        <el-table-column label="操作" width="70">
          <template slot-scope="scope" v-if="!showSortCloumn">
            <div class="table-btn-box" >
              <div v-if="!scope.row.isChild" class="table-btn" @click="handleDelClick(scope.row)">
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table-container-footer">
      <p style="color:#606266;font-size:13px">共 {{this.tableData.length}} 条</p>
      <div class="btn-box" v-if="!this.archiveInfoLoading && !this.tableLoading && this.tableData.length>0">
            <div class="btn" @click="goBack" v-if="!showSortCloumn">返回</div>
            <div class="btn" @click="handleSetDefaultSort" v-if="!showSortCloumn">一键排序</div>
            <div class="btn" @click="handleSetSort" v-if="!showSortCloumn">调整顺序</div>
            <div class="btn" @click="handleSaveSort" v-if="showSortCloumn">完成</div>
            <div class="btn" @click="handlePrintClick">打印</div>
            <download-excel
              class="btn"
              :data="exportData"
              :fields="tableHeader"
              type="xls"
              :header="this.yearTag+'年 '+this.provinceNameTag+' '+this.studentNameTag+' '+this.subjectTag+' 分数区间'+this.scoreRangeTag"
              :name="this.yearTag+'年'+this.provinceNameTag+this.studentNameTag+'填报列表.xls'"
            >
              导出Excel
            </download-excel>
        </div>
    </div>
    
  </div>
</template>
<script>
import JsonExcel from "vue-json-excel";
import printJS from 'print-js';
import Sortable from "sortablejs";
//录取原则
let admissionCriteria = {1:'分数优先',2:'专业优先',3:'分数极差'};
export default {
  name: "batch",
  components: {
    DownloadExcel: JsonExcel,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      tableData: [],
      originalData: [], // Store original data with children
      exportData: [],
      tableLoading:false,
      archiveInfoLoading:false,
      tableShow:true,
      yearTag:"",
      provinceNameTag:"",
      studentNameTag:"",
      scoreRangeTag:"",
      subjectTag:"",
      studentId:0,
      provinceListLoading:false,
      province:"",
      provinceList:[],
      sortable:null,
      showSortCloumn:false,
      tableHeader:{
        '序号':'index',
        '院校专业代码':'code',
        '院校/专业备注':'school',
        '院校/专业':'major',
        '地区':'province',
        '院校层次':'level',
        '录取原则':'majorRequire',
        '学制/学费招生计划比':'tuition',
        '去年录取分':'segment',
        '参考分':'forecast',
        // '学科评估':'sub jectAssessment',
        '保研率':'retentionRate',
        '备注':'remark'
      }
    };
  },
  methods: {
    initArchiveInfo(){
      this.archiveInfoLoading = true;
      if(!this.studentId || this.studentId==0){
        this.$message({
          message: "学生信息有误!请重试!",
          type: "error",
        });
        this.$router.go(-1);
      }
      this.$http.post(this.$apis.getStudentDetail+"?id="+this.studentId).then((res) => {
        this.archiveInfoLoading = false;
        if (res.data) {
          this.yearTag = res.data.year;
          this.provinceNameTag = res.data.provinceName;
          this.studentNameTag = res.data.name;
          this.subjectTag = res.data.course1 + res.data.course2 + res.data.course3;
          this.scoreRangeTag = res.data.score;
        }
      });
    },
    initSelectData(){
      this.provinceListLoading = true;
      //获取省份
      this.$http.post(this.$apis.getProvinceOrCityList+"?type=province").then((res) => {
        this.provinceListLoading = false;
        if (res.data) {
          this.$store.commit("setProvinceList", res.data);
          this.provinceList = res.data.map(r=>{
            return {
              key:r.id,
              label:r.name,
              value:r.id
            }
          });
        }
      });
    },
    initTableData(){
      this.tableLoading=true;
      //获取分页表格数据
      this.$http.post(this.$apis.getStudentAspirationGroupList+"?studentId="+this.studentId).then((res) => {
        this.tableLoading=false;
        if (res.data) {
          this.tableData = res.data.map((r,index)=>{
            return {
                id:r.id,
                index:index + 1,
                province:r.schoolProvinceName,
                city:r.schoolCityName,
                groupCode:r.groupCode,
                school:r.schoolName,
                major:r.applyRecruitingSchemeGroups.map(item => {return `${item.majorName}(${item.estimatedScore == null ? '-' : item.estimatedScore})`}).join(","),
                requireSub:r.course,
                // tuition:r.schoolYearMin+"/"+r.tuitionMin,
                tuition:"",
                level:r.schoolNature,
                compare:this.getCompare(r),
                segment: r.groupLowestScore, //this.getLowestPreYearScore(r.applyRecruitingSchemeGroups) ,
                forecast: r.groupReferenceScore, //this.getLowestEstimatedScore(r.applyRecruitingSchemeGroups),
                retentionRate:r.applyRecruitingSchemeGroups.map(item => item.retentionRate)[0],
                remark:r.note == null?"":r.note,
                majorRequire: r.majorRequire == null ? "" : admissionCriteria[r.majorRequire],
                children:  r.applyRecruitingSchemeGroups.map((data, index) => {
                  return {
                    id:data.id,
                    isChild:true,
                    index:index,
                    groupCode:data.majorCode,
                    len:r.applyRecruitingSchemeGroups?.length,
                    province:data.schoolProvinceName,
                    city:data.schoolCityName,
                    school:'',
                    major:data.majorName,
                    requireSub:data.course,
                    tuition:(data.schoolYear == null ? '-' : data.schoolYear)+"/"+data.tuition,
                    level:data.schoolNature,
                    compare:data.planRate,
                    segment:data.preYearScore,
                    forecast:data.estimatedScore,
                    remark:data.note == null?"":data.note,
                    subjectAssessment:data.subjectAssessment == null?"":data.subjectAssessment,
                  }
                })
            }
          });
          
          this.changExportData()
        }
      });
    },
    getCompare(r){
      let arr = r.applyRecruitingSchemeGroups.map(item=>item.planRate);
      if(arr.length == 0){
        return "";
      }
      // 将数组中的分数字符串解析并求和
      const sum = arr.reduce((acc, curr) => {
        const [numerator, denominator] = curr.split('/').map(Number);
        return {
          numerator: acc.numerator + numerator,
          denominator: acc.denominator + denominator
        };
      }, { numerator: 0, denominator: 0 });
      
      return `${sum.numerator}/${sum.denominator}`;
    },
    getLowestPreYearScore(r){
      let arr = r.map(item=>item.preYearScore);
      if(arr.length == 0){
        return "";
      }
      return arr.reduce((a, b) => Math.min(a, b));
    },
    getLowestEstimatedScore(r){
      let arr = r.map(item=>item.estimatedScore);
      if(arr.length == 0){
        return "";
      }
      return arr.reduce((a, b) => Math.min(a, b));
    },
    changExportData() {
      this.exportData = [];
          this.tableData.forEach((item,index) => {
            // Add parent row with index
            this.exportData.push({
              index: index + 1,
              code: `专业组代码:${item.groupCode}`,
              province: item.province,
              city: item.city,
              school: item.school,
              major: item.major,
              requireSub: item.requireSub,
              tuition: item.tuition,
              level: item.level,
              compare: item.compare,
              segment: item.segment,
              forecast: item.forecast,
              majorRequire: item.majorRequire,
              remark: item.remark,
              retentionRate: item.retentionRate,
            });
            
            // Add children rows if they exist
            if (item.children && item.children.length > 0) {
              item.children.forEach((child,index) => {
                this.exportData.push({
                  index: '',
                  code:`专业代码:${child.groupCode}`,
                  province: child.province,
                  city: child.city,
                  school: child.school,
                  major: child.major,
                  requireSub: child.requireSub,
                  tuition: child.tuition,
                  level: child.level,
                  compare: child.compare,
                  segment: child.segment,
                  forecast: child.forecast,
                  remark: child.remark
                });
              });
            }
          });
    },
    handleDelClick(row){
      this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var data ={
            majorIds: row.children.map(item => item.id),
            studentId: this.studentId
          };
          this.$http.post(this.$apis.deleteAspiration,data).then((res) => {
          if (res.code==200 && res.message==="SUCCESS") {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.initTableData();
              }else{
                this.$message({
                  message: "删除失败!原因:"+res.message,
                  type: "error",
                });
              }
          });
        });
    },
    handleDelSelectClick(){
      this.$refs.tableData.clearSelection();
    },
    handlePrintClick(){
      printJS({
        printable:this.tableData,
        type:'json',
        properties:[
            {displayName:'省份',field:'province',columnSize:'6%'},
            {displayName:'城市',field:'city',columnSize:'6%'},
            {displayName:'院校',field:'school'},
            {displayName:'专业',field:'major'},
            {displayName:'选科要求',field:'requireSub'},
            {displayName:'院校层次',field:"level"},
            {displayName:'学制/学费',field:"tuition"},
            {displayName:'招生计划对比2025/2026',field:"compare"},
            {displayName:'2025年录取分',field:"segment"},
            {displayName:'参考分',field:"forecast"},
            {displayName:'备注',field:"remark"}
          ],
        header:`<div style="display: flex;flex-direction: column;text-align: center">
                  <h3>${this.yearTag}年 ${this.provinceNameTag} ${this.studentNameTag} ${this.subjectTag} 分数:${this.scoreRangeTag} </h3>
                </div>`,
        gridHeaderStyle: 'border: 1px solid #000;text-align:center;font-size: 1px;',
        gridStyle: 'border: 1px solid #000;text-align:center;font-size: 1px;'
      });
    },
    goBack() {
      this.$router.push({
        name: "applicationInfoOther",
        query:{
          studentId: this.studentId
        }
      });
    },
    handleSetSort() {
      this.showSortCloumn = true;
      // Store original data
      this.originalData = JSON.parse(JSON.stringify(this.tableData));
      // Remove children for sorting
      this.tableData = this.tableData.map(item => ({
          ...item,
          children: null
        }));
      const el = this.$refs.tableData.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        handle: '.handle-sort',
        animation: 150,
        setData: function(dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        onEnd: evt => {
          const targetRow = this.tableData.splice(evt.oldIndex, 1)[0];
          this.tableData.splice(evt.newIndex, 0, targetRow);
          this.tableData = this.tableData.map((r,index)=>{
            r.index = index +1
            return {
                ...r,
                   
          }});
        }
      });
    },
    handleSetDefaultSort() {
      if (this.tableData?.length > 0) {
        const majorIds = [];
        let sortTable = this.tableData.sort((a,b) => b.forecast - a.forecast);
        sortTable.forEach((item, index) => {
          majorIds.push(item.id);
        })
        const data = {
          studentId: this.studentId,
          majorIds: majorIds
        };

        this.$http.get(this.$apis.reSetSort, {studentId: parseInt(this.studentId)}).then((res) => {
          if (res?.code == 200 && res.data) {
            this.$message({
              type: 'success',
              message: '排序成功!'
            });
            this.initTableData()
          } else {
            this.$message({
              type: 'error',
              message: '排序失败，请重试!'
            });
          }
        })
      }
    },
    handleSaveSort() {
      if (this.tableData?.length > 0) {
        const majorIds = [];
        this.tableData.forEach((item, index) => {
          if (item) {
            majorIds.push(item.id);
          }
        })
        const data = {
          studentId: this.studentId,
          majorIds: majorIds
        };

        this.$http.post(this.$apis.updateSortByStudent, data).then((res) => {
          // Restore children from original data while maintaining new order
          this.tableData = this.tableData.map(item => {
            const originalItem = this.originalData.find(orig => orig.id === item.id);
            return {
              ...item,
              children: originalItem.children
            };
          });
          this.changExportData()
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.showSortCloumn = false;
        });
      } else {
        this.showSortCloumn = false;
      }
    },
    handleChildClickup(row) {
      const parentRow = this.tableData.find(item => 
        item.children && item.children.some(child => child.id === row.id)
      );
      
      if (parentRow && row.index > 0) {
        this.tableLoading = true;
        const children = parentRow.children;
        const currentIndex = row.index;

        const node1 = children[currentIndex];
        const node2 = children[currentIndex - 1];

        // 调用后台接口，更新sort
        this.$http.post(this.$apis.changeSort, {studentId: parseInt(this.studentId), majorId1: node1.id, majorId2: node2.id}).then((res) => {
          if(res?.code === 200 && res.data) {
            // Use array splice for more efficient swapping
            const [movedItem] = children.splice(currentIndex, 1);
            children.splice(currentIndex - 1, 0, movedItem);
            
            // Update indices
            children.forEach((child, index) => {
              child.index = index;
            });
            this.changExportData()
            this.tableLoading = false;
          } else {
            this.$message({
              type: 'error',
              message: '调整顺序失败，请重试!'
            });
            this.tableLoading = false;
          }
        });
      }
    },
    
    handleChildClickdown(row) {
      const parentRow = this.tableData.find(item => 
        item.children && item.children.some(child => child.id === row.id)
      );
      
      if (parentRow && row.index < parentRow.children.length - 1) {
        this.tableLoading = true;
        const children = parentRow.children;
        const currentIndex = row.index;

        const node1 = children[currentIndex];
        const node2 = children[currentIndex + 1];

        // 调用后台接口，更新sort
        this.$http.post(this.$apis.changeSort, {studentId: parseInt(this.studentId), majorId1: node1.id, majorId2: node2.id}).then((res) => {
          if(res?.code === 200 && res.data) {
            // Use array splice for more efficient swapping
            const [movedItem] = children.splice(currentIndex, 1);
            children.splice(currentIndex + 1, 0, movedItem);
            
            // Update indices
            children.forEach((child, index) => {
              child.index = index;
            });
            
            this.tableLoading = false;
            this.changExportData()
          } else {
            this.$message({
              type: 'error',
              message: '调整顺序失败，请重试!'
            });
            this.tableLoading = false;
          }
        });
      }
    },
  },
  mounted(){
    this.studentId = this.$route.query.studentId;
    this.initArchiveInfo();
    this.initSelectData();
    this.initTableData();
  },
};
</script>
<style lang="less" scoped>
.batch-search {
  margin: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  border-radius: 5px;
  border: 1px solid rgba(230, 230, 230, 100);

  .top-box {
    display: flex;
    align-items: center;
    padding: 13px 10px;
    border-bottom: 1px solid rgba(230, 230, 230, 100);

    .archive-info-container{
        padding-left: 400px;
        p{
          text-align: center;
          font-size: 24px;
        }
    }
    .top-title {
      color: rgba(16, 16, 16, 100);
      font-size: 20px;
      font-weight: 700;
      padding-left: 20px;
      position: relative;
    }
    .top-title::after {
      position: absolute;
      display: block;
      content: "";
      top: 50%;
      left: 5px;
      transform: translateY(-50%);
      height: 27px;
      width: 3px;
      background-color: #ff450b;
    }

  }
  
  .form-group{
      padding: 0px 20px;
    .form-item {
      display: flex;
      align-items: center;
      padding: 15px 0;
      .label {
        display: flex;
        justify-content: flex-end;
        color: rgba(100, 100, 100, 100);
        font-size: 14px;
        width: 70px;
        padding-right:10px;
      }
      .input-box {
          display: flex;
          width: calc(100% - 100px);
      }
      .required-label{
            color: rgb(255, 0, 0);
      }
      .action-link{
          font-size: 16px;
          cursor:pointer;
          color: #ff450b;
          padding-right: 20px;
      }
    }
  }
  .form-control{
      width: 100%;
  }
  .table-container-body {
    .table-body{
      width: 100%;
      overflow: auto;
    }
    .handle-sort{
      cursor: pointer;
      font-size: 20px;
    }
    .selected{
      background-color: #f9c7c8;
      border: solid red 1px !important;
    }
    .table-btn-box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .table-btn {
        cursor: pointer;
        width: 60px;
        line-height: 28px;
        border-radius: 14px;
        color: rgba(121, 160, 241, 100);
        font-size: 12px;
        text-align: center;
        border: 1px solid rgba(121, 160, 241, 100);
      }
    }
  }
  .table-container-footer{
    padding: 5px 15px;
    display: flex;
    justify-content: space-between;
    .btn-box {
      display: flex;
      align-items: center;
      .btn {
        line-height: 32px;
        width: 95px;
        border-radius: 4px;
        background-color: rgba(255, 69, 11, 100);
        text-align: center;
        color: #fff;
        margin-left: 15px;
        cursor: pointer;
        font-size: 14px;
      }
    }
  }
  .bottom-box{
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    .btn-box {
      padding: 0px 20px;
      display: flex;
      align-items: center;
      .btn {
        line-height: 32px;
        width: 95px;
        border-radius: 4px;
        background-color: rgba(255, 69, 11, 100);
        text-align: center;
        color: #fff;
        margin-left: 15px;
        cursor: pointer;
        font-size: 14px;
      }
    }
  }
}
</style>
